import { useState } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { useNavigate } from 'react-router-dom';

export function useAccountDeletion() {
  const [confirmText, setConfirmText] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    try {
      // TODO: Replace with real API call if available
      // await api.post('/profile/delete', { reason });
      await new Promise((resolve) => setTimeout(resolve, 1500));
      setSuccess(true);
      setTimeout(() => {
        auth.signoutRedirect();
        navigate('/login');
      }, 2000);
    } catch {
      setError('Erro ao solicitar exclusão de conta');
    } finally {
      setLoading(false);
    }
  };

  return { confirmText, setConfirmText, reason, setReason, loading, error, success, handleDelete };
}
